import React from 'react'
import Logo from '../general/navbar/Logo.jsx'

const Footer = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-dknavy p-2 text-sm text-center text-white font-display">
      <div className="flex justify-center w-full">
        <div className="flex items-center justify-center w-full pt-2 text-xs/6 space-x-4">
          <div className="flex p-3 w-1/5 ">
            <Logo />
          </div>
          <div className="flex flex-col w-3/4 space-y-2">
            <div className="flex justify-around pb-2">
              <div>
                <h1 className="font-semi text-base">Headquarters<br /></h1>
                <h1 className='text-md'>734 E Main St<br /></h1>
                Branford, CT
              </div>
              <div>
                <span className="font-bold text-base ">Shop<br /></span>
                9 Baldwin Dr<br />
                Branford, CT
              </div>
            </div>
            <div className="flex justify-around">
              <div>
                <span className="font-bold text-base ">Franklin Office<br /></span>
                254 E Central St<br />
                Franklin, MA
              </div>
              <div>
                <span className="font-bold text-base ">Contact Us<br /></span>
                203-488-2377<br />
                203-488-6381
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 className="text-xs mt-4">Copyright © 2025 Massey's Glass  |  Privacy Policy  |  All Rights Reserved</h1>
    </div>
  )
}

export default Footer
